// extracted by mini-css-extract-plugin
module.exports = {"color-text-grey":"#707070","colorTextGrey":"#707070","from":"_2MBcX _1D3zw _1Zmlx"};